import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=a9058b2e&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"
import style0 from "./Swiper.vue?vue&type=style&index=0&id=a9058b2e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9058b2e",
  null
  
)

export default component.exports